'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
require('../node_modules/prop-types/index.js');
var TotalCell = require('./TotalCell.js');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var ROW_HEIGHT = 36;
var TOTALS_HEIGHT = 56;
var Totals = /*#__PURE__*/React__namespace.memo(_ref => {
  var {
    columns,
    totals
  } = _ref;
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: "GenjoDataTable__totals",
    style: {
      height: TOTALS_HEIGHT
    }
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: "GenjoDataTable__cell",
    style: {
      width: ROW_HEIGHT,
      maxWidth: ROW_HEIGHT,
      minWidth: ROW_HEIGHT
    }
  }), columns.map((column, index) => totals !== null && totals !== void 0 && totals[column.dataKey] ? /*#__PURE__*/React__namespace.createElement(TotalCell.TotalCell, _rollupPluginBabelHelpers['extends']({
    key: column.dataKey
  }, totals[column.dataKey], {
    column: column
  })) : /*#__PURE__*/React__namespace.createElement("div", {
    key: column.dataKey,
    className: "GenjoDataTable__cell",
    style: {
      width: column.width,
      maxWidth: column.width,
      minWidth: column.width
    }
  })));
});
Totals.displayName = 'Totals';
Totals.propTypes = {};

exports.Totals = Totals;
